export default __webpack_public_path__ + "static/media/user.3dfb5ca2.svg";